import Api from "./Api";

export default {
    load(beerCount, country, voucher, vatid) {
        let url = `/calc/pricing?beers=${beerCount}&country=${country}`;
        if (voucher) url += `&voucher=${voucher}`;
        if (vatid) url += `&vatid=${vatid}`;
        return Api.get(url);
    }
}